module.exports = __webpack_public_path__ + "img/twitter.3f74b3d8.svg";